import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable, Subject, take } from 'rxjs';
import { ConfirmDialogComponent } from '../components/shared-components/confirm-dialog/confirm-dialog.component';
import { hasUnsavedChanges } from '../utils/form.utils';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(private dialogService: DialogService) {}

  /**
   * confirmDeactivation
   * @param currentValue the current value of the form
   * @param initialValue the initial value of the form
   * @returns Observable<boolean> if the user wants to leave the page
   */
  public confirmDeactivation(
    currentValue: any,
    initialValue: any
  ): Observable<boolean> {
    // check if the form has unsaved changes
    if (hasUnsavedChanges(initialValue, currentValue)) {
      const deactivateSubject = new Subject<boolean>();
      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        width: '475px',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
          '640px': '90vw',
        },
        data: {
          title: 'Ungespeicherte Änderungen',
          message:
            'Es gibt ungespeicherte Änderungen. Wenn Sie die Seite verlassen, gehen Daten verloren.',
          icon: 'fa-regular fa-exclamation-triangle',
          iconColor: 'yellow',
          confirmButtonText: 'Verlassen',
        },
      });

      dialogRef.onClose.pipe(take(1)).subscribe(dialogResult => {
        deactivateSubject.next(dialogResult);
      });

      return deactivateSubject.asObservable();
    }
    return new Observable<boolean>(observer => {
      observer.next(true);
      observer.complete();
    });
  }
  public markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
      if (control instanceof FormArray) {
        control.controls.forEach(c => {
          if (c instanceof FormGroup) {
            this.markFormGroupTouched(c);
          } else {
            c.markAsTouched();
          }
        });
      }
    });
  }
}
